module.exports = __webpack_public_path__ + "img/artichaut.5cdbea6b.jpeg";